module.exports = __webpack_public_path__ + "img/pattern-down.54c06e52.png";